import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n/LanguageContext";

const SITE_NAME = "BATIK Tour & Travel";
const DEFAULT_KEYWORDS = "travel umrah, travel haji, PPIU, PIHK, umrah silver gold platinum titanium, umrah plus turki, umrah plus kuala lumpur, umrah aqsha, haji plus, haji furoda, badal umrah, BATIK Tour Travel, PT Baitullah Tiga Kharisma";

export default function SEO({
  title,
  titleEn,
  description,
  descriptionEn,
  image,
  type = "website",
  keywords,
}) {
  const { lang } = useLang();
  const finalTitle = (lang === "id" ? title : titleEn || title) || "BATIK Tour & Travel — Travel Umrah & Haji Resmi PPIU & PIHK";
  const finalDesc = (lang === "id" ? description : descriptionEn || description) || "BATIK Tour & Travel (PT Baitullah Tiga Kharisma) — travel umrah & haji resmi berizin PPIU & PIHK Kementerian Agama RI. Paket Silver, Gold, Platinum, Titanium, Umroh Plus, Haji Plus, dan Haji Furoda.";
  const finalKeywords = keywords || DEFAULT_KEYWORDS;
  const url = typeof window !== "undefined" ? window.location.href : "";
  const finalImage = image || "https://static.prod-images.emergentagent.com/jobs/c612f9b0-bd89-4c85-9451-5b81c8951306/images/f1f475b83a82c8878244837e71398856f2bc016914c4ec6b3dd67163757f40df.png";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{`${finalTitle} | ${SITE_NAME}`}</title>
      <meta name="description" content={finalDesc} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={SITE_NAME} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={lang === "id" ? "id_ID" : "en_US"} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />

      {/* JSON-LD: TravelAgency */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "TravelAgency",
        "name": "PT Baitullah Tiga Kharisma — BATIK Tour & Travel",
        "image": finalImage,
        "description": finalDesc,
        "url": url,
        "telephone": "+6282114294101",
        "email": "batikumrahhaji.bekasi@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Jaticempaka, Pondok Gede",
          "addressLocality": "Kota Bekasi",
          "addressRegion": "Jawa Barat",
          "postalCode": "17411",
          "addressCountry": "ID"
        },
        "sameAs": [
          "https://instagram.com/batikumrah.bekasi",
          "https://tiktok.com/@batikumrah.bekasi",
          "https://facebook.com/batikumrah.bekasi"
        ]
      })}</script>
    </Helmet>
  );
}
